// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__pUkiE","label":"Labeled_label__1OMOX","divider":"Labeled_divider__3_yM0"};